import * as React from 'react';
import {
  CreateGuesser,
  EditGuesser,
  FieldGuesser,
  InputGuesser,
  ListGuesser,
  Filter
} from "@api-platform/admin";
import {
  ArrayInput,
  NumberInput,
  ReferenceInput,
  SimpleFormIterator,
  TextInput,
  Button,
  DateInput,
  DateField,
  Link
} from 'react-admin';
import CustomImageInput from '../field/CustomImageInput';
import PromotionalOffers from "./promotionalOffers";
import ReferenceSelectionInput from "../field/ReferenceSelectionInput";
import Queue from '@material-ui/icons/Queue';

function omitId(record) {
  if (record['@id']) { delete record['@id']; }
  if (record['@context']) { delete record['@context']; }
  if (record['@type']) { delete record['@type']; }

  Object.keys(record).forEach(key => {
    if (record[key] && record[key]['@id']) {
      record[key] = omitId(record[key]);
    }

    if (Array.isArray(record[key])) {
      record[key] = omitId(record[key]);
    }
  });

  return record;
}

const CustomCloneButton = ({ record }) => {
  let entity = JSON.parse(JSON.stringify(record));

  if (entity.picture) { delete entity.picture; }
  if (entity.promotionalOffer) { delete entity.promotionalOffer; }
  if (entity.id) { delete entity.id; }
  if (entity.actualPrice) { delete entity.actualPrice; }

  entity = omitId(entity);

  return (
  <Button
    component={Link}
    to={{
      pathname: '/daily_products/create',
      state: { record: entity },
    }}
    label='Dupliquer le produit'
    color='secondary'
  >
  <Queue />
  </Button>
);
};

const DailyProducts = {
  List: props => {
    const EmbeddedPromotionalOffers = PromotionalOffers.EmbeddedPromotionalOffers;

    return (
      <ListGuesser {...props}>
        <FieldGuesser source="name" label="Nom du menu"/>
        <EmbeddedPromotionalOffers addLabel={true} label="Remise"/>
        <DateField source="availableAt" label="Date" options={{month: 'numeric', day: 'numeric'}} locales="fr-FR"/>
        <FieldGuesser source="quantity" label="Quantité"/>
      </ListGuesser>
    )
  },
  Create: props => (
    <CreateGuesser {...props}>
      <InputGuesser source="name" label="Nom du menu"/>
      <TextInput multiline source="description" label="Description"/>
      <CustomImageInput {...props} source="picture" label="Image"/>
      <InputGuesser source="price" label="Prix" defaultValue={10}/>
      <InputGuesser source="quantity" label="Quantité" defaultValue={30}/>

      <ArrayInput source="accompanimentCategories" reference="accompaniment_categories"
                  label="Catégorie d'accompagnements">
        <AccompanimentCategories/>
      </ArrayInput>
    </CreateGuesser>
  ),
  Edit: props => {
    return (
      <EditGuesser {...props}>
        <CustomCloneButton record={props.record}/>
        <InputGuesser source="name" label="Nom du menu"/>
        <DateInput   source="availableAt" label="Disponible le"/>
        <TextInput multiline source="description" label="Description"/>
        <CustomImageInput {...props} source="picture" label="Image"/>
        <InputGuesser source="price" label="Prix"/>
        <InputGuesser source="quantity" label="Quantité"/>

        <ArrayInput source="accompanimentCategories" reference="accompaniment_categories"
                    label="Catégorie d'accompagnements">
          <AccompanimentCategories/>
        </ArrayInput>
      </EditGuesser>
    );
  }
};

const AccompanimentCategories = props => {
  let inlineStyle = {float: 'left', marginLeft: '20px'};

  return (
    <SimpleFormIterator {...props}>

      <TextInput source="name" label="Nom de la catégorie"/>

      <NumberInput source="min" label={"Nombre min. à sélectionner"} style={inlineStyle}/>
      <NumberInput source="max" label={"Nombre max. à sélectionner"} style={inlineStyle}/>

      <ArrayInput {...props} source="accompaniments" label="Accompagnements">
        <SimpleFormIterator>

          <TextInput source="name" label="Nom" style={inlineStyle}/>
          <NumberInput source="price" label="Prix (supplément)" style={inlineStyle}/>

        </SimpleFormIterator>
      </ArrayInput>

    </SimpleFormIterator>
  );
}

export default DailyProducts;
